import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './TarifBiaya.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

const TarifBiayaTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
  }

  return (
    <>
    <TableWrapper
      baseId="mod-table-sample"
      title={t.translate('modules.tarifBiaya.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Dari',
          searchable: true,
          key: 'dari',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.dari)
        },{
          label: 'Ke',
          searchable: true,
          key: 'ke',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.ke)
        },{
          label: 'Jenis Biaya',
          searchable: true,
          key: 'jenisBiaya',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.jenisBiaya)
        },
        {
          label: 'Tarif',
          searchable: true,
          key: 'tarif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarif)
        },{
          label: 'Sebulan',
          searchable: true,
          key: 'sebulan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.sebulan)
        },{
          label: 'Setahun',
          searchable: true,
          key: 'setahun',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.setahun)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/tarif-biaya/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/tarif-biaya/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default TarifBiayaTable
